// extracted by mini-css-extract-plugin
export var hidden = "_uo-0";